import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wetf4ksst: FaireProductEntity = {
  token: "p_7wetf4ksst",
  type: "product",
  name: "Blue Birds Anniversary Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/af2529c587daee645ad94fe3d89f0f3900be5acdf068e6fa31ebcdf2c0972a2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6431527b283a69c3207e88ced97ee77b4264528cf7ae1514661fa8ca7190ca7.jpeg",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:00.623Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
